export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('pwa:dev-sw-template', (template) => {
    // Ensure dev-sw.js file will always be different and triggers updates
    const timestamp = Date.now()
    return `/* Updated at: ${timestamp} */\n${template}`
  })
  nuxtApp.hook('service-worker:registered', ({ url, registration }) => {
    // eslint-disable-next-line no-console
    console.log(`service worker registered at ${url}`, registration)    
  })
  nuxtApp.hook('service-worker:registration-failed', ({ error }) => {
    console.error(`service worker registration failed`, error)
  })
  nuxtApp.hook('service-worker:activated', ({ url, registration }) => {
    // eslint-disable-next-line no-console
    console.log(`service worker activated at ${url}`, registration)
    // useUserStore().autoUpdateClient = true
  })
  nuxtApp.hook('service-worker:updatefound', ({ url, registration }) => {
    // eslint-disable-next-line no-console
    console.log(`service worker update found at ${url}`, registration)
    useUserStore().autoUpdateClient = true
  })
})